import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { InsurancePackage } from '@lib/insurance-packages/data-access';

import { InsurancePackageItemComponent } from './insurance-package-item/insurance-package-item.component';

@Component({
  selector: 'insurance-packages-list',
  standalone: true,
  imports: [InsurancePackageItemComponent],
  templateUrl: './insurance-package-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsurancePackageListComponent {
  insurancePackages = input.required<InsurancePackage[]>();
}
